const varsityInfo = {
    fullName : 'Chittagong University of Engineering & Technology',
    address:'Pahartoli, Raozan-4349,Chittagong, Bangladesh',
    shortDesc:'Chittagong University of Engineering & Technology (CUET) is one of the leading Public University of Bangladesh. It is situated alongside the Chittagong Capital road 25km away from the city of Chittagong.',
    contactNo:'+880-31-714946',
    email:[
      'iict@cuet.ac.bd', 'registrar@cuet.ac.bd'
    ]
  }

export default varsityInfo